import React from "react";
import { AppBar, Toolbar } from 'ceci-ui';
import Menu from './Menu';
import Logo from './Logo';
import SearchBox from './SearchBox';
import Account from './Account';

const App = () => {
  return (
    <AppBar>
      <Toolbar>
        <Logo />
        <Menu />
        <SearchBox />
        <Account />
      </Toolbar>
    </AppBar>
  );
}

export default App
